<template>
  <q-btn-dropdown
    v-if="options"
    class="inspection-status text-white"
    :class="`bg-${selectedStatus.color}`"
    :label="selectedStatus.label"
    no-caps
    no-item-animation
    content-class="inspection-status-dropdown"
    :disable="isTerminalState(selectedStatus.value)"
  >
    <q-list>
      <q-item
        v-for="(option, key) in options"
        :key="key"
        v-close-overlay
        :disabled="key === 'PAYMENT_FAILED'"
        class="text-white cursor-pointer mx-3 my-2 rounded"
        :class="`bg-${option.color}`"
        clickable
        @click.native="setStatus(option.value)"
      >
        {{ option.label }}
      </q-item>
    </q-list>
  </q-btn-dropdown>
</template>

<script>
import { isTerminalState } from '@/utils/InspectionUtil';
import config from '../plugins/bluejay/config';

const { inspectionStates } = config;
export default {
  name: 'InspectionStateDropdown',
  props: {
    current: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      options: inspectionStates,
      selectedStatus: this.getStatusByValue(this.current),
    };
  },
  watch: {
    current() {
      this.selectedStatus = this.getStatusByValue(this.current);
    },
  },
  methods: {
    isTerminalState,
    setStatus(status) {
      const notPaymentFailedState = status !== 'payment_failed';
      if (this.isTerminalState(status) && notPaymentFailedState) {
        return this.$emit('change', status);
      }
      if (this.selectedStatus.value === inspectionStates.WAITING_FOR_TENANT.value && status !== this.selectedStatus.value && notPaymentFailedState) {
        return this.$emit('change', status);
      }
      if (notPaymentFailedState) {
        this.selectedStatus = this.getStatusByValue(status);
        this.$emit('change', status);
      }
    },
    getStatusByValue(value) {
      return Object.values(inspectionStates).find((status) => status.value === value);
    },
  },
};
</script>

<style lang="scss">
.inspection-status {
    width: 155px;
    padding: 0.25rem;
  .q-icon.on-right {
      margin-left: 0.25rem;
  }
}
.inspection-status-dropdown {
    animation: none;
    .q-list{
        animation: none;
        .q-item {

            min-height: auto;
            &:hover {
                transform: scale(1.05);
            }
        }
    }
}
</style>
